import React from "react";
import { useTheme } from "../../providers/ThemeContext";

type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  subtitleColor?: string;
  subTitleSize?: number;
  children?: React.ReactNode;
};

export default function HeaderSection({
  eyebrow,
  title,
  subtitle,
  subtitleColor,
  subTitleSize = 16,
  children,
}: Props) {
  const { theme } = useTheme();
  const styles = ContactStyles(
    theme,
    subtitleColor ?? theme.muted,
    subTitleSize
  );
  return (
    <>
      {eyebrow ? <div style={styles.eyebrow}>{eyebrow}</div> : null}
      <h1 style={styles.title}>{title}</h1>
      {subtitle ? <p style={styles.subTitle}>{subtitle}</p> : null}
      {children}
    </>
  );
}

const ContactStyles = (
  theme: any,
  subtitleColor: string,
  subTitleSize: number
) => {
  return {
    eyebrow: {
      fontSize: 14,
      letterSpacing: 1,
      textTransform: "uppercase" as const,
      color: theme.text,
      fontWeight: 700,
    },
    title: {
      margin: "6px 0 10px",
      fontSize: 40,
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      lineHeight: 1.1,
    },
    subTitle: { color: subtitleColor, maxWidth: 420, fontSize: subTitleSize },
  };
};
